import { Typography } from "@mui/material";
import { _CO, _MONTHS } from "../../../utils/constants";
import { createColumn } from "../../../utils/function";
import {
  ARRAY_INCLUDE_RATE_DIESEL,
  DIESEL_IMPACT,
  EXCAVATOR_LRU_RS,
  LORRIES_TRANSPORT_RS,
  PLUMS_COST_RS,
  PLUMS_RS_T,
  PROD_LRL_WASTE_TONS,
  TOTAL_COST_RS_T,
} from "./AgGridQuarryingExcavator";
import {
  processCalculateFinalValue,
  processRowsIncludeRateDiesel,
  processRowsTotalCostRsT,
} from "./function-quarrying";
import { currencyFormatter } from "../../../utils/AgGridUtils/ColumnBuilders/createColumn";

export const ColumnBuilder = ({ budgetParameters } = {}) => {
  const buildColumns = () => {
    const generatedColumns = [];

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "",
          field: "theme",
          rowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return params.data.theme;
          },
          supressCount: true,
        },
        {
          headerName: "Rate",
          field: "rate",
          /**
           * @desc Check if the theme is included in the ARRAY_INCLUDE_RATE_DIESEL if true then editable is true
           */
          editable: (params) => {
            return (
              ARRAY_INCLUDE_RATE_DIESEL.includes(params.data?.theme) &&
              params.data?.subThemes !== DIESEL_IMPACT
            );
          },
          flex: 1,
          cellRenderer: (params) => {
            return ARRAY_INCLUDE_RATE_DIESEL.includes(params.data?.theme) &&
              params.data?.subThemes !== DIESEL_IMPACT ? (
              <strong>{currencyFormatter(params?.value, "", 2)}</strong>
            ) : (
              ""
            );
          },
        },
        {
          headerName: "Sources",
          field: "subThemes",
          flex: 3.5,
          cellRenderer: (params) => {
            const { node } = params;

            if (node.footer) {
              switch (node.key) {
                case PLUMS_COST_RS:
                  return "Total " + PLUMS_COST_RS;
                case LORRIES_TRANSPORT_RS:
                  return "Total " + LORRIES_TRANSPORT_RS;
                case EXCAVATOR_LRU_RS:
                  return "Total " + EXCAVATOR_LRU_RS;
                default:
                  return params.data?.subThemes;
              }
            }

            return (
              <Typography variant="body2" title={params.data?.subThemes}>
                {params.data?.subThemes}
              </Typography>
            );
          },
        },
      ]),
    );

    for (let i = 1; i <= 12; i++) {
      const fiscalMonthIndex = _CO[i];
      generatedColumns.push(
        ...createColumn([
          {
            headerName: _MONTHS[fiscalMonthIndex],
            field: `${fiscalMonthIndex}`,
            editable: (params) => {
              return (
                params.data?.theme === PLUMS_RS_T ||
                params.data?.subThemes === DIESEL_IMPACT
              );
            },
            headerClass: "month-header",
            aggFunc: "sum",
            flex: 1,
            cellRenderer: (params) => {
              if (
                params.data?.subThemes === DIESEL_IMPACT ||
                ARRAY_INCLUDE_RATE_DIESEL.includes(params.data?.theme) ||
                params.data?.theme === PLUMS_RS_T
              ) {
                return params?.value > 0
                  ? currencyFormatter(params?.value, "", 2)
                  : "";
              } else if (params.data?.theme === PROD_LRL_WASTE_TONS) {
                return params?.value > 0
                  ? currencyFormatter(params?.value, "T")
                  : "";
              }

              return (
                <Typography
                  variant="body2"
                  title={currencyFormatter(params?.value)}
                >
                  {currencyFormatter(params.value, "")}
                </Typography>
              );
            },
            valueParser: (params) => {
              if (params.newValue == null) {
                return 0;
              }

              const valueAsString = String(params.newValue);

              const cleanValue = valueAsString
                .replace(/\s/g, "")
                .replace(/,/g, ".");

              return parseFloat(cleanValue) || 0;
            },
            valueGetter: (params) => {
              const { api, data, node } = params;

              /**
               * @desc Process rows with themes included in ARRAY_INCLUDE_RATE_DIESEL
               */
              if (
                data &&
                ARRAY_INCLUDE_RATE_DIESEL.includes(data?.theme) &&
                data?.rate &&
                data?.subThemes !== DIESEL_IMPACT
              ) {
                return processRowsIncludeRateDiesel(data, api, node, i);
              } else if (data?.theme === TOTAL_COST_RS_T) {
                return processRowsTotalCostRsT(data, api, node, i);
                /* Calculate the final value (ton * rate) */
              } else if (data?.theme?.toLowerCase().endsWith("rs.")) {
                return processCalculateFinalValue(data, api, node, i);
              }

              const value = Number(data?.[fiscalMonthIndex] || 0);
              return Number(value.toFixed(2));
            },
          },
        ]),
      );
    }

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "TOTAL",
          field: "total",
          headerClass: "total-header-col",
          aggFunc: "sum",
          flex: 1,

          valueGetter: (params) => {
            const { data } = params;

            if (!data) return 0;

            if (
              ARRAY_INCLUDE_RATE_DIESEL.includes(data?.theme) ||
              data?.theme === TOTAL_COST_RS_T ||
              data?.theme === PLUMS_RS_T
            ) {
              return null;
            }

            const total = Array.from({ length: 12 }, (_, i) => i + 1).reduce(
              (sum, month) => sum + (Number(data?.[month]) || 0),
              0,
            );

            return Number(total.toFixed(2));
          },
          cellRenderer: (params) => {
            if (params.value === null) {
              return "";
            }

            if (params.data?.theme === PROD_LRL_WASTE_TONS) {
              return currencyFormatter(params.value, "T");
            }

            return (
              <Typography
                variant="body2"
                title={currencyFormatter(params?.value, "")}
              >
                {currencyFormatter(params.value, "")}
              </Typography>
            );
          },
        },
      ]),
    );

    return generatedColumns;
  };

  return buildColumns();
};
